import { getBrowserVersion, isSafari, preciseIOSVersion } from './browser';
/**
 * Insert element after another element in DOM
 * @param afterNode
 * @param newNode
 */
export function insertAfter(afterNode, newNode) {
    if (afterNode.parentNode) {
        afterNode.parentNode.insertBefore(newNode, afterNode.nextSibling);
    }
}
/**
 * Get the topmost window we're allowed access to
 */
export function getTopSafeFrame() {
    let w = window;
    // As long as a parent exists
    while (w.parent && w !== w.parent) {
        try {
            w.parent.location.href;
            if (!w.parent.document) {
                break;
            }
            w = w.parent;
        }
        catch (_a) {
            break;
        }
    }
    return w;
}
/**
 * If we have access to top window, return it.
 */
export function accessTopWindow() {
    var _a;
    let topWindow;
    // Check if top window is accessible
    try {
        // Break if access to document is forbidden (throws an error)
        const readyState = (_a = window.top) === null || _a === void 0 ? void 0 : _a.document.readyState;
        topWindow = readyState ? window.top : undefined;
        // eslint-disable-next-line no-empty
    }
    catch (_b) { }
    return topWindow;
}
export function isIframe(w = window) {
    try {
        return w.self !== window.top;
    }
    catch (_a) {
        return true;
    }
}
export const safeCompareWindows = (a, b) => {
    try {
        return a === b;
    }
    catch (_a) {
        return false;
    }
};
export const tryGetHref = (win) => {
    var _a;
    try {
        return ((_a = win.location) === null || _a === void 0 ? void 0 : _a.href) || null;
    }
    catch (_b) {
        return null;
    }
};
export const tryGetTop = (win) => {
    try {
        return win.top || win;
    }
    catch (_a) {
        return win;
    }
};
export const tryGetSelf = (win) => {
    try {
        return win.self || win;
    }
    catch (_a) {
        return win;
    }
};
/**
 * Iframe load event does not occur in iOS 16.3 or Safari 17 (OSX) because
 * `contentWindow` never gets initialized if 'about:blank' is set as src
 * and the parent wrapping iframe has a different src (e.g) javascript:''.
 * Note that 'about:blank' is in the WHATWG standard.
 * This only happens in certain iframe environments, e.g Adform's
 *
 * Related tickets:
 * ADA-1055
 * AD-793
 */
export function emptyIframeSrc() {
    const isSafari17 = isSafari && getBrowserVersion() >= 17;
    return isSafari17 || preciseIOSVersion.simple >= 16.3 ? `javascript:''` : 'about:blank';
}
/**
 * Ensures that the styles won't change, even if the user enables the "Auto dark mode" option in chrome
 */
export function addColorSchemeMetaTag(iframe) {
    var _a;
    const meta = document.createElement('meta');
    meta.name = 'color-scheme';
    meta.content = 'light only';
    (_a = iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.head.appendChild(meta);
}
